import EscPosEncoder from "esc-pos-encoder";
import { printReceipt } from ".";
import { attachImage, dottedLine, padSpaces, row, softwareBy, wrapText } from "./helpers";

export const consumptionPrint = async (consumptionData) => {
  const encoder = new EscPosEncoder();

  const { company, customer, lastPayment, summary, readings, printedDate } = consumptionData;

  const columnWidths = [17, 15];
  const totalWidth = columnWidths.reduce((a, b) => a + b);

  const footer = await attachImage(
    `${window.location.origin}/images/pay_before_21_days.PNG`,
    "center"
  );

  const commands = [];

  if (company.logo) {
    const logo = await attachImage(company.logo, "center");
    commands.push(logo);
  } else {
    commands.push(new TextEncoder("utf-8").encode(`\x1B\x21\x30${company.name}\n`));
  }

  commands.push(dottedLine(totalWidth, true));
  commands.push(
    encoder.initialize().align("center").line("HOT LINE").line(company.phone_number).encode()
  );
  commands.push(dottedLine(totalWidth, true));
  commands.push(encoder.initialize().align("center").line("Consumption Receipt").encode());
  commands.push(dottedLine(totalWidth, true));

  commands.push(encoder.initialize().line(`Acc No : ${customer.account}`).encode());

  const nameLines = wrapText(customer.name, 23);
  nameLines.forEach((nameLine, index) => {
    if (index === 0) {
      commands.push(encoder.initialize().bold(false).line(`Name   : ${nameLine}`).encode());
    } else {
      commands.push(
        encoder
          .initialize()
          .bold(false)
          .line(`${padSpaces(" ", 9, "left")}${nameLine}`)
          .encode()
      );
    }
  });

  const addressLines = wrapText(customer.address, 23);
  addressLines.forEach((addressLine, index) => {
    if (index === 0) {
      commands.push(encoder.initialize().bold(false).line(`Address: ${addressLine}`).encode());
    } else {
      commands.push(
        encoder
          .initialize()
          .bold(false)
          .line(`${padSpaces(" ", 9, "left")}${addressLine}`)
          .encode()
      );
    }
  });
  commands.push(dottedLine(totalWidth));

  if (lastPayment) {
    const { date, amount } = lastPayment;
    commands.push(encoder.initialize().bold(true).align("center").line("LAST PAYMENT").encode());
    commands.push(row([date, amount], columnWidths));
    commands.push(dottedLine(totalWidth));
  }

  readings.forEach((reading, index) => {
    const {
      readingDate,
      lastReadingDate,
      daysCount,
      currentReading,
      lastReading,
      usage,
      charge,
      calculation,
    } = reading;
    commands.push(
      encoder
        .initialize()
        .bold(true)
        .align("center")
        .line(`${lastReadingDate} - ${readingDate}`)
        .encode()
    );
    commands.push(row(["Days", daysCount], columnWidths));
    commands.push(encoder.initialize().bold(true).line("Units / Usage").encode());
    commands.push(
      encoder
        .initialize()
        .align("center")
        .line(`${currentReading} - ${lastReading} = ${usage}`)
        .encode()
    );
    commands.push(encoder.initialize().line(" ").encode());
    commands.push(encoder.initialize().bold(false).line(calculation).encode());
    commands.push(encoder.initialize().line(" ").encode());
    commands.push(row(["Charge:", charge], columnWidths));
    commands.push(dottedLine(totalWidth));
  });

  const { outstanding, charge, totalDue } = summary;
  commands.push(row(["Outstanding:", outstanding], columnWidths));
  commands.push(row(["Charge:", charge], columnWidths));
  commands.push(row(["Total Due:", totalDue], columnWidths));
  commands.push(dottedLine(totalWidth));
  commands.push(footer);
  commands.push(dottedLine(totalWidth));
  commands.push(encoder.initialize().align("center").line(`Printed ${printedDate}`).encode());
  commands.push(dottedLine(totalWidth));
  commands.push(softwareBy());
  commands.push(encoder.initialize().newline().newline().newline().encode());

  printReceipt(commands);
};
